import $ from 'jquery';

export default class CollapseItem {
    constructor(el) {
        this.DOM = { el };
        this.DOM.collapse = document.querySelector(el.dataset.collapseItem);

        if (this.DOM.collapse) {
            this.initEvents();
        }
    }

    initEvents() {
        $(this.DOM.collapse).on('show.bs.collapse', () => {
            this.DOM.el.classList.add('collapse-show');
        });
        $(this.DOM.collapse).on('hide.bs.collapse', () => {
            this.DOM.el.classList.remove('collapse-show');
        });
    }
}

const collapseItemNodes = document.querySelectorAll('[data-collapse-item]');
collapseItemNodes.forEach((node) => new CollapseItem(node));
